// extracted by mini-css-extract-plugin
export var typingIndicator = "_pb-0";